import Vue from "vue";
import notSupportedMixin from "@/mixins/notSupportedMixin";
export default Vue.extend({
    mixins: [notSupportedMixin]
});
